import { useState, useCallback } from 'react';

import { Modal } from '../../../components/Modal';
import { getModules } from '@/actions/data-fetch-modules';
import { toastMessage } from '@/utils/toast-message';
// import UsersTable from './UsersTable';
import SettingHeader from '../../../components/settings/SettingHeader';

import { ModulesApiData, ModulesDetail } from '../../../types/settings/ModuleTypes';
import { PaginationProps } from '../../../types/settings/settings';
import ModulesTable from './ModulesTable';
import CreateNewModuleForm from '../../../components/Forms/CreateNewModuleForm';

export function ModulesClientWrapper({ initialData, pagination }: ModulesApiData) {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedModule, setSelectedModule] = useState<ModulesDetail | null>(null);
  const [data, setData] = useState<ModulesDetail[]>(initialData || []);
  const [currentPagination, setCurrentPagination] = useState<PaginationProps | undefined>(pagination);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortColumn, setSortColumn] = useState<string>('');
  const [sortOrder, setSortOrder] = useState<'ASC' | 'DESC'>('ASC');


  const fetchData = useCallback(async (params: {
    page: number,
    search_term?: string,
    sort_column?: string,
    sort_order?: 'ASC' | 'DESC'
  }) => {
    try {
      setIsLoading(true);
      const response = await getModules(params);
      if (response.data) {
        setData(response.data.modules || []);
        setCurrentPagination(response.data.pagination);
      }


    }
    catch (error: unknown) {
      if (error instanceof Error) {
        toastMessage(error.message, "error"); // Accessing error.message when it's an instance of Error
      } else {
        toastMessage("An unknown error occurred", "error"); // Fallback for non-Error types
      }
    } finally {
      setIsLoading(false);
    }
  }, []);


  const handleOpenModal = (modules?: ModulesDetail) => {
    setSelectedModule(modules || null);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {



    setSelectedModule(null);

    setIsModalOpen(false);




  };
  const handleSuccess = async (updatedModule: ModulesDetail) => {
    // Optimistic update of local state
    setData(prevData => {
      // If user exists, update; otherwise, add new user
      const moduleIndex = prevData.findIndex(u => u.uuid === updatedModule.uuid);
      if (moduleIndex !== -1) {
        // Update existing user
        const newData = [...prevData];
        newData[moduleIndex] = updatedModule;
        return newData;
      } else {
        // Add new user
        return [...prevData, updatedModule];
      }
    });

    await fetchData({
      page: currentPagination?.currentPage || 1,
      search_term: searchTerm,
      sort_column: sortColumn,
      sort_order: sortOrder
    });

    handleCloseModal();

    // Show success message
    toastMessage(
      selectedModule ? 'Module updated successfully' : 'Module created successfully',
      'success'
    );
  }




  const handlePageChange = async (page: number) => {
    await fetchData({
      page,
      search_term: searchTerm,
      sort_column: sortColumn,
      sort_order: sortOrder
    });
  };

  const handleSearch = async (term: string): Promise<void> => {
    setSearchTerm(term);
    await fetchData({
      page: 1,
      search_term: term,
      sort_column: sortColumn,
      sort_order: sortOrder
    });
  };

  const handleSort = async (column: string, order: 'ASC' | 'DESC'): Promise<void> => {
    setSortColumn(column);
    setSortOrder(order);
    await fetchData({
      page: currentPagination?.currentPage || 1,
      search_term: searchTerm,
      sort_column: sortColumn,
      sort_order: order
    });
  };

  return (
    <>



      <SettingHeader
        heading="Text"
        para="Text"
        btnTxt="Text"
        onClick={() => handleOpenModal()}
      />

      <div className="p-6">
        <ModulesTable
          initialData={data}
          onEdit={handleOpenModal}
          pagination={currentPagination}
          onPageChange={handlePageChange}
          onSearch={handleSearch}
          onSort={handleSort}
          isLoading={isLoading}
          searchTerm={searchTerm}
          sortColumn={sortColumn}
          sortOrder={sortOrder}
        />
      </div>

      {isModalOpen && (
        <Modal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          position="right"
          title="Text"
          size="half"
          showBackdrop={true}
        >
          <CreateNewModuleForm
            onClose={handleCloseModal}
            uuid={selectedModule?.uuid}
            initialData={selectedModule}
            onSuccess={handleSuccess}
          />
        </Modal>
      )}





    </>
  );


}